import { MapsData } from '@/types/typesInterfaces';
import { fetchMapsReview } from '@/utils/client/client_api';
import { DEFAULT_REVIEWS_RATING } from '@/utils/constants';
import Link from 'next/link';
import { useEffect, useState } from 'react';

interface WizardFooterProps {
  locale: string;
}

export default function WizardFooter({ locale }: WizardFooterProps) {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [reviews, setReviews] = useState<number>(DEFAULT_REVIEWS_RATING);


  const getLastReview = async () => {
    setIsLoading(true);
    try {
      const resp = await fetchMapsReview();
      if (resp.isOk) {
        setReviews(resp.response!.rating)
      }
    } finally {
      setIsLoading(false);
    }


  }

  useEffect(() => {
    getLastReview();
  }, [])

  return (
    <footer className={`wizard-footer ${isLoading ? 'blur-xs' : ''}`} >
      <div className="footer-features">
        <div className="footer-feature">
          <span className="feature-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20" height="20"><path className="fa-secondary" opacity=".4" fill="#3762e9" d="M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288l111.5 0L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7l-111.5 0L349.4 44.6z" /><path className="fa-primary" fill="#3762e9" d="" /></svg>
          </span>
          <span className="feature-text">
            {locale === 'it' ? 'Primo risultato immediato' : 'First immediate result'}
          </span>
        </div>

        <div className="footer-feature">
          <span className="feature-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="20" height="20"><path className="fa-secondary" opacity=".4" fill="#3762e9" d="M16 139.7c.5 99.5 41.3 281 213.6 363.5c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c0-26.4-16.4-47.9-38.3-57.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8C32.4 92.1 16 113.6 16 139.7zM136 256c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l47 47c37-37 74-74 111-111c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c2.3 2.3 4.1 5 5.3 7.9c.6 1.4 1 2.9 1.3 4.4c.2 1.1 .3 2.2 .3 2.2c.1 1.2 .1 1.2 .1 2.5c-.1 1.5-.1 1.9-.1 2.3c-.1 .7-.2 1.5-.3 2.2c-.3 1.5-.7 3-1.3 4.4c-1.2 2.9-2.9 5.6-5.3 7.9c-42.7 42.7-85.3 85.3-128 128c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-21.3-21.3-42.7-42.7-64-64c-4.7-4.7-7-10.8-7-17z" /><path className="fa-primary" fill="#3762e9" d="M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z" /></svg>
          </span>
          <span className="feature-text">
            {locale === 'it' ? '100% online e sicuro' : '100% online and secure'}
          </span>
        </div>

        <div className="footer-feature ${isLoading ? 'blur-xs' : ''}">
          <span className="feature-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="20" height="20"><path className="fa-secondary" opacity=".4" fill="#3762e9" d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" /><path className="fa-primary" fill="#3762e9" d="" /></svg>
          </span>
          <span className="feature-text">
            {reviews} {locale === 'it' ? 'su' : 'on'} Google Reviews
          </span>
        </div>
      </div>
    </footer>
  );
}